import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M459.896763,902.84233 L459.896763,1592.68747 L1494.66448,1592.68747 L1494.66448,1017.81652 L1724.72783,1017.81652 L1724.72783,1822.63586 L229.948381,1822.63586 L229.948381,902.84233 L459.896763,902.84233 Z M1759.26608,331.926488 L1920,496.454555 L1074.9397,1322.31417 L666.896296,923.468699 L827.745188,759.055607 L1074.9397,1000.73136 L1759.26608,331.926488 Z M459.896763,98 L459.896763,328.063356 L689.960118,328.063356 L689.960118,558.011737 L459.896763,558.011737 L459.896763,787.845144 L229.948381,787.845144 L229.948381,558.011737 L5.68434189e-14,558.011737 L5.68434189e-14,328.063356 L229.948381,328.063356 L229.948381,98 L459.896763,98 Z M1379.71328,327.982874 L1379.71328,557.931255 L804.84233,557.931255 L804.84233,327.982874 L1379.71328,327.982874 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCheckPlusSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCheckPlusSolid, _Component);

  var _super = _createSuper(IconCheckPlusSolid);

  function IconCheckPlusSolid() {
    _classCallCheck(this, IconCheckPlusSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCheckPlusSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCheckPlus",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCheckPlusSolid.displayName = "IconCheckPlusSolid";
  return IconCheckPlusSolid;
}(Component);

IconCheckPlusSolid.glyphName = 'check-plus';
IconCheckPlusSolid.variant = 'Solid';
IconCheckPlusSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCheckPlusSolid;
export { IconCheckPlusSolid };